import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Icon } from '@studio/legacy-components';
import Tag, { TagTypes } from 'components/Common/Tag';

const StyledIcon = styled(Icon)`
  transition: all 0.2s ease;
  position: absolute;
  right: 1em;
  top: 0.7em;
  cursor: pointer;
  &:hover {
    color: red;
  }
`;

const StyledTagName = styled.p`
  text-align: center;
  margin: 0;
  padding: 0.25em;
  white-space: nowrap;
`;

const StyledTag = styled(Tag)`
  display: flex;
  align-items: center;
  font-weight: normal;
  font-size: 0.75em;
  height: 24px;
  transition: all 0.2s ease;
  position: relative;
  ${StyledIcon} {
    opacity: 0;
  }
  &:hover {
    padding-right: 2.25em;
    ${StyledIcon} {
      opacity: 1;
    }
  }
`;

const FlowTag = ({ name, id, onDelete }) => (
  <StyledTag type={TagTypes.GRAY_10}>
    <StyledTagName>{name}</StyledTagName>
    <StyledIcon title="Remove tag" icon="times" onClick={() => onDelete(id)} />
  </StyledTag>
);

FlowTag.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  onDelete: PropTypes.func,
};

export default FlowTag;
